module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/files_play-5ecdb28f683ce83cd4944dc1a82af4d5.svg";